export function start(state) {
    return state
        .set('isTyping', true);
}

export function stop(state) {
    return state
        .set('isTyping', false);
}
